import { render, staticRenderFns } from "./SongModal.vue?vue&type=template&id=7572a207"
import script from "./SongModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SongModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports